import { Root, createRoot } from 'react-dom/client';
import { state } from './state';

export const ensureRoot = (): Root => {
    if (state.root) return state.root;
    const el = document.getElementById('react-ui');
    if (!el) throw new Error("Element with id 'react-ui' not found");
    state.root = createRoot(el);
    return state.root;
};
